if (typeof window.modalPostcodeChecker === "undefined") {
  window.modalPostcodeChecker = async () => {
    const MODULE_NAME = "Postcode Checker";
    const MODAL_SELECTOR = "#modal-postcode-checker";
    const POSTCODE_CHECKER_ENDPOINT =
      "https://app.stockmansteaks.com.au/storefront/api/v1/check-postcode";
    const STORAGE_KEY = "stockman_postcode_checker";

    const printLog = (message, extra) => {
      console.log(
        "%c" + MODULE_NAME,
        "font-weight: bold; color: #000; background: #c7facd; border-radius: 3px; padding: 0 5px;",
        message,
        extra || ""
      );
    };

    const validateRequiredScripts = async (timeout = 5000) => {
      const start = Date.now();
      while (true) {
        if (typeof window.jQuery === "function") return;
        if (Date.now() - start >= timeout) {
          printLog("Timeout waiting for jQuery");
          return;
        }
        await new Promise((r) => setTimeout(r, 50));
      }
    };

    const waitForGoogleMaps = async (timeout = 10000) => {
      const start = Date.now();
      while (true) {
        if (
          typeof window.google !== "undefined" &&
          google.maps &&
          google.maps.places
        ) {
          return;
        }
        if (Date.now() - start >= timeout) {
          printLog("Timeout waiting for Google Maps");
          return;
        }
        await new Promise((r) => setTimeout(r, 100));
      }
    };

    const toggleModal = ($el, value) => {
      const $body = $("body");
      const $modal = $el.hasClass("modal-mini")
        ? $el
        : $el.closest(".modal-mini");

      if (value) {
        $modal.fadeIn("fast");
        $body.addClass("modal-mini-active");
      } else {
        $modal.fadeOut("fast");
        $body.removeClass("modal-mini-active");
      }
    };

    const toggleFormLoading = ($form, value) => {
      const $submit = $form.find("[type=submit]");
      const $spinner = $form.find(".loading-overlay__spinner");

      if (!$submit.length || !$spinner.length) return;

      if (value) {
        $submit.addClass("loading").attr("disabled", "disabled");
        $spinner.removeClass("hidden");
      } else {
        $submit.removeClass("loading").removeAttr("disabled");
        $spinner.addClass("hidden");
      }
    };

    const showMessage = (message, isSuccess) => {
      const $message = $("#postcode-checker-message");
      
      if (!$message.length) {
        return;
      }

      if (!message) {
        $message.hide().text("");
        $message.removeClass(
          "postcode-checker--success postcode-checker--error"
        );
        return;
      }

      $message
        .text(message)
        .show()
        .removeClass("postcode-checker--success postcode-checker--error")
        .addClass(
          isSuccess
            ? "postcode-checker--success"
            : "postcode-checker--error"
        );
    };

    const updateCurrentSelectionUI = (selection) => {
      const $el = $("#postcode-checker-current");
      if (!$el.length) return;

      if (!selection) {
        $el.hide().text("");
        return;
      }

      $el
        .html(`
          <div class="notification-box notification-box--success">
            We deliver to <strong>${selection.suburb} ${selection.postcode}</strong>
          </div>
        `)
        .show();
    };

    const saveSelection = (suburb, postcode) => {
      try {
        const payload = { suburb, postcode, timestamp: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        updateCurrentSelectionUI(payload);
      } catch (e) {
        console.error(e);
      }
    };

    const loadSelection = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || !data.suburb || !data.postcode) return null;
        return data;
      } catch (e) {
        console.error(e);
        return null;
      }
    };

    const clearSelection = () => {
      try {
        localStorage.removeItem(STORAGE_KEY);
        updateCurrentSelectionUI(null);
      } catch (e) {
        console.error(e);
      }
    };

    const initFromLocalStorage = () => {
      const saved = loadSelection();
      if (!saved) {
        updateCurrentSelectionUI(null);
        return;
      }

      $("#postcode-checker-suburb").val(saved.suburb);
      $("#postcode-checker-postcode").val(saved.postcode);
      $("#postcode-checker-input").val(saved.suburb + " " + saved.postcode);

      updateCurrentSelectionUI(saved);
    };

    const submitPostcodeForm = ($form) => {
      const suburb = $("#postcode-checker-suburb").val().trim();
      const postcode = $("#postcode-checker-postcode").val().trim();

      console.log({ suburb, postcode });

      if (!suburb || !postcode) {
        showMessage(
          "Please select a suburb and postcode from the suggestions.",
          false
        );
        return;
      }

      toggleFormLoading($form, true);
      showMessage("", false);

      const url =
        POSTCODE_CHECKER_ENDPOINT +
        "?zip=" +
        encodeURIComponent(postcode) +
        "&city=" +
        encodeURIComponent(suburb);

      clearSelection();

      console.log(url);

      fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((res) => res.json())
        .then((data) => {
          // { status: boolean, message: string, canBeDelivered: boolean }
          const ok = !!data.status;
          const deliverable = !!data.canBeDelivered;
          const msg =
            data.message ||
            (ok
              ? "Delivery status received."
              : "Unable to check delivery at this time.");

          if (!ok)
          showMessage(msg, ok && deliverable);

          if (ok && deliverable) {
            saveSelection(suburb, postcode);
          } else if (ok && !deliverable) {
            showMessage("We don't deliver to that suburb & postcode at this time.");
          } else {
            showMessage(data.message || "Unable to check delivery at this time.", false);
          }

          // Hook here if you want to act on canBeDelivered
        })
        .catch(() => {
          showMessage(
            "Something went wrong while checking your postcode. Please try again.",
            false
          );
        })
        .finally(() => {
          toggleFormLoading($form, false);
        });
    };

    const initAutocomplete = () => {
      const input = document.getElementById("postcode-checker-input");
      if (!input) {
        printLog("Input element not found");
        return;
      }

      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        printLog("Google Maps not available");
        return;
      }

      const ac = new google.maps.places.Autocomplete(input, {
        types: ["geocode"],
        componentRestrictions: { country: "au" },
        fields: ["address_components", "geometry", "place_id"]
      });

      ac.addListener("place_changed", () => {
        const place = ac.getPlace();
        
        if (!place || !place.address_components) {
          return;
        }

        let suburb = "";
        let postcode = "";

        // Extract suburb and postcode from the initial Autocomplete selection
        place.address_components.forEach((c) => {
          const types = c.types || [];
          if (
            types.includes("locality") ||
            types.includes("postal_town") ||
            types.includes("sublocality")
          ) {
            suburb = c.long_name;
          }
          if (types.includes("postal_code")) {
            postcode = c.long_name;
          }
        });

        // Populate the suburb right away
        $("#postcode-checker-suburb").val(suburb);

        // 2. Fallback: If postcode is empty but we have coordinates, use Reverse Geocoding
        if (!postcode && place.geometry && place.geometry.location) {
          const geocoder = new google.maps.Geocoder();
          
          geocoder.geocode({ location: place.geometry.location }, (results, status) => {
            if (status === "OK" && results) {
              // Look through the geocoded results for a postal code
              for (let i = 0; i < results.length; i++) {
                const components = results[i].address_components;
                const foundPostalCode = components.find(c => c.types.includes("postal_code"));
                
                if (foundPostalCode) {
                  postcode = foundPostalCode.long_name;
                  break; // Stop looking once we find it
                }
              }
            }
            
            // Populate the postcode field (either the found fallback or empty if completely unavailable)
            $("#postcode-checker-postcode").val(postcode);
          });
        } else {
          // If postcode was already found by Autocomplete, populate it immediately
          $("#postcode-checker-postcode").val(postcode);
        }
      });
    };

    const setupEvents = () => {
      // Submit
      $(document).on("submit", "[data-postcode-checker-form]", function (e) {
        e.preventDefault();
        console.log('submitting data-postcode-checker-form')
        submitPostcodeForm($(this));
      });

      // Close buttons and overlay
      $(".modal-mini").on("click", "[data-close-modal]", function (e) {
        e.preventDefault();
        toggleModal($(this), false);
      });

      // Open modal
      $(document).on("click", "[data-toggle='postcode-checker']", function (e) {
        e.preventDefault();
        toggleModal($(MODAL_SELECTOR), true);
      });
    };

    await validateRequiredScripts();
    setupEvents();
    initFromLocalStorage();
    await waitForGoogleMaps();
    initAutocomplete();

    printLog("modal-postcode-checker.js loaded");
  };

  (function () {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        window.modalPostcodeChecker();
      });
    } else {
      window.modalPostcodeChecker();
    }
  })();
}